// extracted by mini-css-extract-plugin
module.exports = {"card":"CMSCard_card__H1j4b"};